import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { SITE_URL } from "../../components/seo/Seo";
import PageShell, { PageHero } from "./PageShell";
import ServicesV2 from "../components/ServicesV2";
import DoorsV2 from "../components/DoorsV2";
import { Arrow } from "../components/Primitives";
import { pickLang } from "../copy";
import { route } from "../paths";

const ServicesPageV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const isFr = lang === "fr";

  return (
    <PageShell
      seo={{
        title: isFr
          ? "Services de nettoyage de baskets : Standard, Luxe, Enfant | Lave Tes Baskets"
          : "Sneaker cleaning services: Standard, Luxury, Kids | Lave Tes Baskets",
        description: isFr
          ? "Nettoyage complet dès 20€, soin Luxe pour cuir et daim, formule Enfant. En option : collecte & livraison dès 15€, express 24h ou 48h, imperméabilisation dès 2€ par paire."
          : "Complete cleaning from €20, Luxury care for leather and suede, Kids formula. Add-ons: pickup & delivery from €15, 24h or 48h express, waterproofing from €2 per pair.",
        canonicalPath: route(lang, "services"),
        jsonLd: [
          {
            "@context": "https://schema.org",
            "@type": "Service",
            name: isFr ? "Nettoyage de sneakers" : "Sneaker cleaning",
            provider: { "@type": "LocalBusiness", name: "Lave Tes Baskets" },
            areaServed: "Île-de-France",
            url: `${SITE_URL}${route(lang, "services")}`,
          },
        ],
      }}
    >
      <PageHero
        crumbs={[
          { label: isFr ? "Accueil" : "Home", to: route(lang) },
          { label: "Services" },
        ]}
        index="01"
        eyebrow={isFr ? "Services" : "Services"}
        title={
          isFr ? (
            <>
              Ce qu'on fait, <em className="italic text-tangerine">paire</em> par paire.
            </>
          ) : (
            <>
              What we do, <em className="italic text-tangerine">pair</em> by pair.
            </>
          )
        }
        lede={
          isFr
            ? "Six façons de prendre soin de vos sneakers. Chaque service se compose avec vos options, le prix s'affiche avant de confirmer."
            : "Six ways to care for your sneakers. Every service builds with your add-ons, the price shows before you confirm."
        }
        actions={
          <>
            <Link to={`/${lang}/signup`} className="v2-btn v2-btn-solid">
              {isFr ? "Laver ma paire" : "Wash my pair"}
              <Arrow />
            </Link>
            <Link to={route(lang, "tarifs")} className="v2-btn v2-btn-ghost">
              {isFr ? "Voir les tarifs" : "See pricing"}
            </Link>
          </>
        }
        aside={
          <img
            src="/illustrations/landing/nettoyage.webp"
            alt=""
            className="ml-auto w-full max-w-[440px] object-contain"
          />
        }
      />
      <ServicesV2 hideHeader />
      <section className="bg-ink py-16 text-bone sm:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
          <DoorsV2 />
        </div>
      </section>
    </PageShell>
  );
};

export default ServicesPageV2;
